import findByReferenceSlug from "./find-by-reference-slug";

export default function findSeasonContentForSchoolLevel(season, schoolLevel) {
  return findByReferenceSlug(
    season?.seasonContentForSchoolLevel,
    "schoolLevel",
    schoolLevel?.slug,
  );
}
